import axios from "axios";

// const api_endpoint = 'http://127.0.0.1:5001'
// const api_endpoint = 'https://staging.enterprise.api.docmasweetspot.ca'
const api_endpoint = 'https://fn6mi7qqjd.execute-api.us-east-2.amazonaws.com/dev'
// const api_endpoint = 'https://d6itaje8h6.execute-api.us-east-2.amazonaws.com/prod'

function get_optimization_data(token, payload) {
  let api_url = api_endpoint + "/forecasting/optimization/data";
  return axios_post_call(api_url, payload, token);
}

/*
Base Caller functions
*/
function axios_post_call(api_url, data, token) {
  return new Promise(function (resolve, reject) {
    axios
      .post(api_url, data, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data);
        } else {
          reject();
        }
      })
      .catch((e) => {
        reject(api_url + e);
      });
  });
}

export default {
  get_optimization_data,
};
